import { Injectable } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { Employee } from '../models/employee';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {
  readonly VAPID_PUBLIC_KEY = environment.webPush.publicKey

  constructor(private swPush: SwPush, private apiServ: ApiService) { }

  subscribeToNotifications(user: Employee) {
    this.swPush.requestSubscription({
      serverPublicKey: this.VAPID_PUBLIC_KEY
    }).then(sub => {
      // Enviar al backend para guardar
      if (user.subscriptions?.length) {
        const existingSub = user.subscriptions.find(s => s.endpoint === sub.endpoint);
        if (existingSub) {
          console.log('Ya existe una suscripción con este endpoint');
          return; // Ya está suscrito
        }
      }
      this.apiServ.doEmployee('SUBSCRIBE_PUSH_NOTIFY', {
        subscription: sub
      }).then(() => {
        console.log('Suscripción exitosa:', sub);
      }).catch(err => {
        console.error('Error al guardar la suscripción:', err);
      })
    }).catch(err => console.error('No se pudo suscribir:', err));
  }
}
